import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  accounts: {}
}

export const getters = {}

export const mutations = {
  ACCOUNTS(state, request) {
    state.accounts = request
  }
}

export const actions = {

  init({ state, dispatch }) {},

  fetchAccounts(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/accounts/${query}`).then((response) => {
      const request = response.data
      context.commit('ACCOUNTS', request)
      return request
    })
  },

  createUpdateAccount(context, formData) {
    let promise = null
    if (formData.update){
      promise =  axios.put(`${serverUrl}/api/accounts/${formData.id}/`, formData)
    }else {
      promise =  axios.post(`${serverUrl}/api/accounts/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

}
